/*
 * AdminSettings Messages
 *
 * This contains all the text for the AdminSettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.common.language',
    defaultMessage: 'Language',
  },
  intro: {
    id: 'app.components.AdminSettings.languageIntro',
    defaultMessage: 'The language selected here determines in which language invitations will be sent. Users can select their language of preference in their account settings.',
  },
});
